import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const STORAGE_KEY = 'cp.settings.temp_check_enabled';
const QUERY_KEY = ['settings', 'temp_check_enabled'] as const;

function readPref(): boolean {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw === null ? true : raw === '1';
}

export function useTempCheck() {
  const queryClient = useQueryClient();

  const { data: enabled = true } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: readPref,
    staleTime: Infinity,
  });

  const setEnabled = useCallback(
    (value: boolean) => {
      queryClient.setQueryData(QUERY_KEY, value);
      localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    },
    [queryClient]
  );

  return { enabled, setEnabled } as const;
}
